function normalize(email: string): string {
  return email.trim().toLowerCase();
}

export const isVisitorEmailConflict = (
  visitorEmail?: string,
  submitterEmail?: string
): boolean => {
  if (!visitorEmail || !submitterEmail) return false;

  return normalize(visitorEmail) === normalize(submitterEmail);
};
